import axios from '../../services/axios.service';
import { getEndpointBase } from '../../services/api.service';
import {
  InternshipListParams,
  InternshipListPeopleResponse,
  InternshipRequest,
} from './Internship.type';
import { AddInternshipCandidateThunkPayload } from './Internship.thunk';

let metaRequest: any = null;
let listRequest: any = null;
let infoRequest: any = null;

const InternshipService = {
  getMeta: () => {
    metaRequest && metaRequest.cancel();
    metaRequest = axios.CancelToken.source();
    return axios.get(getEndpointBase('internships/meta'), {
      cancelToken: metaRequest.token,
    });
  },
  getList: (params: InternshipListParams) => {
    listRequest && listRequest.cancel();
    listRequest = axios.CancelToken.source();

    return axios.get(getEndpointBase('internships'), {
      cancelToken: listRequest.token,
      params: {
        page_size: params.pageSize,
        page: params.page || 1,
        sort: params.sort,
        filter: {
          tab: params.tab,
          ...params.filter,
        },
      },
    });
  },
  getPeopleList: (id: number | string, params: InternshipListParams) => {
    listRequest && listRequest.cancel();
    listRequest = axios.CancelToken.source();
    const { sort, filter, search, pageSize: page_size, page = 1 } = params;
    return axios.get(getEndpointBase(`internships/${id}/people`), {
      cancelToken: listRequest.token,
      params: {
        page_size,
        page,
        sort,
        search,
        filter,
      },
    });
  },
  addPeople: (id: string, payload: AddInternshipCandidateThunkPayload) => {
    return axios.post(getEndpointBase(`internships/${id}/people`), {
      personId: payload.id,
      regionId: payload.regionId,
    });
  },
  getInfo(id: number | string) {
    infoRequest && infoRequest.cancel();
    infoRequest = axios.CancelToken.source();
    return axios.get(getEndpointBase(`internships/${id}`), {
      cancelToken: infoRequest.token,
    });
  },
  create(payload: InternshipRequest) {
    return axios.post(getEndpointBase('internships/'), payload);
  },
  update({ id, ...params }: InternshipRequest) {
    return axios.put(getEndpointBase(`internships/${id}`), {
      ...params,
    });
  },
  destroy(id: number | string) {
    return axios.delete(getEndpointBase(`internships/${id}`));
  },
  removeCandidate(
    internshipId: string,
    candidateId: number | string,
  ): Promise<InternshipListPeopleResponse> {
    return axios.delete(
      getEndpointBase(`internships/${internshipId}/people/${candidateId}`),
    );
  },
};

export default InternshipService;
